/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverPaymentEditorAddPaymentRule: "driver-payment-editor-add-payment-rule",
  driverPaymentEditorRemovePaymentRule: "driver-payment-editor-remove-payment-rule",
  driverPaymentEditorAddDeductionRule: "driver-payment-editor-add-deduction-rule",
  driverPaymentEditorRemoveDeduction: "driver-payment-editor-remove-deduction",
  driverPaymentEditorAddBonusRule: "driver-payment-editor-add-bonus-rule",
  driverPaymentEditorRemoveBonus: "driver-payment-editor-remove-bonus",
  driverPaymentEditorSaveChanges: "driver-payment-editor-save-changes",
} as const;
